// START Open Requre.JS wrapper
define([
	'jquery',
	'wcs.context',
	'pubsub',
	'shared.main.screen'
], function($,ctx,pubsub,screenSize) {
// END Open Require.JS wrapper


/****
* Populates the wishlist link in the utility nav
***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "utilityNavWishlist";
	var utilityNavWishlist;
	
	(function(){
		utilityNavWishlist = {
			defaults: {
				el: ".topnav-utility .wishlist, .topnav-smallheader-container .wishlist, .topnav-util-js .nav-wishlist-qty-js", // CMS Topnav Selector, Legacy Topnav Selector
				dataAttr: "wishlist-options",
				replaceString: '{count}', 					// String to replace with quantity
				replaceElement: "<span class=\"qty topnav-wishlist-qty\"/>", 	// Type of element to use in replacement
				classHasProducts: 'has-products', 			// Class to add to the cart when it is not empty
				quantitySelector: '.qty', 					// Selector for the element where quanity will be displayed
				wishlistNotification: '.topnav-wishlist-notification',
				notify: {
					timeout: 5000
				}
			},

			/**
			 * Initialize plugin
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				// Make adjustments for Legacy Topnav
				// TODO - Remove this when Vans switches to CMS Topnav
				if(self.$element.hasClass('nav-wishlist-qty-js')) {
					self.config.quantitySelector = '.nav-wishlist-qty-js';
					self.config.replaceElement = '<span class="nav-wishlist-qty-js"/>';
					self.config.replaceString = '';
				}

				// check for wishlist notification
				self.$wishlistNotification = $(self.config.wishlistNotification);
				if(self.$wishlistNotification.length) {
					// get options passed from aem
					self.config.notify = $.extend( {}, self.config.notify, self.$wishlistNotification.data(self.defaults.dataAttr));
					// set the position of the notification 
					self.positionNotification();

					// remove additional massaging if notification has already been seen once per session
					if(sessionStorage.getItem("wishlistNotificationSeen")) {
						self.$wishlistNotification.find('.wishlist-message, .button').remove();
					}
				}

				self.events();

				self.deferred.resolve();

				return self.update();
			},

			/**
			 * Setup events that update the wishlist link
			 **/
			events: function() {
				var self = this;
				// Update count when user adds to wishlist
				$.pubsub('subscribe', 'WISHLIST_UPDATED', function(event,data) { 
					self.update();

					var suppressNotification = (data && data.suppressNotification) ? data.suppressNotification : false;

					// show wishlist notification except when item is removed or event suppresses it
					if(event.indexOf("remove") < 0 && !suppressNotification) {
						self.showNotification();
					}
				});

				// Update count when user removes from wishlist

				// Update count when page is loaded

				// Update count when user logs in

				// Update count when user logs out

				// Update count on order confirmation since cart should now be empty

				// position wishlist notification under wishlist link when screen resizes
				$.pubsub('subscribe','window.resize.breakpoint',function() {
					self.positionNotification();
				});

				if(self.$wishlistNotification.length) {
					self.$wishlistNotification.find('.close-button').on('click', function() {
						self.hideNotification();
					});
				}
			},

			/**
			 * Update the wishlist link
			 **/
			update: function() {
				var self = this;
				return self.updateDisplay( self.getCount() );
			},

			/**
			 * Get the current number of items in the wishlist per
			 * user cookies
			 **/
			getCount: function() {
				var count = Number(ctx.getWishList().quantity);
				return (isNaN(count)) ? 0 : count;
			},

			/**
			 * Creates an element to display the quantity and injects it
			 **/
			createQtyElement: function() {
				var self = this,
					$qty = $(self.config.replaceElement);

				// Insert the replacement element
				self.$element.html(function(idx, html) {
					return html.replace(self.config.replaceString,$qty.get(0).outerHTML);
				});

				// Find the new qty element since DOM context was lost when it was inserted
				$qty = $(self.config.quantitySelector,self.$element);

				return $qty;
			},

			replaceAttributes: function () {
				var self = this;
				var replacements = [];
				self.$element.children().each(function (index, elem) {
					$.each(elem.attributes, function(i, attrib){
						// replace the count in attribute values with the exception of class names
						if (attrib.name !== "class" && attrib.value.indexOf(self.config.replaceString) > -1) {
							attrib.value = attrib.value.replace(self.config.replaceString, self.getCount());
							replacements.push({
								'currentCount': self.getCount(),
								'$element': $(elem),
								'attrib': attrib.name
							});
						}
					});
				});
				return replacements;
			},
			/**
			 * Update the displayed count of items in the wishlist
			 * @param int Number to display in wishlist
			 **/
			updateDisplay: function(count) {
				var self = this,
					$qty = $(self.config.quantitySelector,self.$element);

					try {
						//make sure no elements have attributes with counts in them
						if (!self.config.replaceAttrs || self.config.replaceAttrs.length === 0) {
							self.config.replaceAttrs = self.replaceAttributes();
						}
						else if (self.config.replaceAttrs && self.config.replaceAttrs.length > 0){
							$.each(self.config.replaceAttrs, function(index, item) {
								if (item.$element.attr(item.attrib)) {
								   item.$element.attr(item.attrib, item.$element.attr(item.attrib).replace(item.currentCount, count));
								}
							});
						}
					}
					catch(err) {
						console.log(err);
					}
				if($qty.length <= 0) {
					// Create a replacement object
					$qty = self.createQtyElement();
				}
				
				// Update count in display
				$qty.text(count);
				
				
				// Set appropriate class on utility nav item
				if(count > 0) {
					self.$element.addClass(self.config.classHasProducts);
				} else {
					self.$element.removeClass(self.config.classHasProducts);
				}

				// Set a flag for better performance in subsequent updates (Future use)
				self.config.replaced = true;

				// Unhide link
				self.$element.removeClass('hide');

				// Allow for chaining
				return self;
			},

			getIndexOfFirstVisibleElement: function($el) {
				var index;
				$el.each(function(i) {
					if($(this).is(':visible')) {
						index = i;
						return false;
					}
				});
				return index;
			},

			// on large screens, the notification should be centered below the wishlist link in utility nav
			positionNotification: function() {
				var self = this;
				
				if(self.$wishlistNotification.length) {
					if(screenSize.size() === "large" || screenSize.size() === "xlarge") {
						var wishlistX = self.$element[self.getIndexOfFirstVisibleElement(self.$element)].offsetLeft,
							wishlistW = self.$element.outerWidth(),
							notifyW = self.$wishlistNotification.outerWidth(),
							winW = $(window).width();

						// offset position from right to center of wishlist link
						var xPos = winW - wishlistX - (wishlistW / 2);

						// prevent notification from being set offscreen right
						if(xPos < (notifyW / 2)) {
							xPos = (notifyW / 2);
						}
						
						// prevent notification from being set offscreen left
						if(xPos > (winW - (notifyW / 2))) {
							xPos = winW - (notifyW / 2);
						}

						// set notification position
						self.$wishlistNotification.css("right", xPos);
					}
					else {
						// unset notification position for small/medium screens
						self.$wishlistNotification.css("right", '');
					}
				}
			},

			showNotification: function() {
				var self = this;
				
				if(self.$wishlistNotification.length) {
					self.positionNotification();

					// Callback for when animation completes
					var animationComplete = function() {

						// start timer to automatically close notification, 
						// if timeout value is set to 0 in aem, then don't close notification
						if(self.config.notify.timeout != 0) {
							window.setTimeout(function() {
								self.hideNotification();
							}, self.config.notify.timeout);
						}

						// remove this event listener so it only gets triggered once
						self.$wishlistNotification[0].removeEventListener('transitionend', animationComplete);
					};

					// Setup event listener for the css transition finishes
					self.$wishlistNotification[0].addEventListener('transitionend', animationComplete);

					// fade in notification
					self.$wishlistNotification.removeClass('hide');
					self.clientWidth = self.$wishlistNotification[0].clientWidth; // force layout to ensure the now display: block and opacity: 0 values are taken into account when the CSS transition starts.
					self.$wishlistNotification.addClass('fade-in');

					// set session variable to track if notification has been seen
					sessionStorage.setItem("wishlistNotificationSeen", "true");
				}
			},

			hideNotification: function() {
				var self = this;

				// Callback for when animation completes
				var animationComplete = function() {

					// hide notification when animation completes
					self.$wishlistNotification.addClass('hide');

					// remove additional massaging after first time alert displays
					self.$wishlistNotification.find('.wishlist-message, .button').remove();

					// remove this event listener so it only gets triggered once
					self.$wishlistNotification[0].removeEventListener('transitionend', animationComplete);
				};

				// Setup event listener for the css transition finishes
				self.$wishlistNotification[0].addEventListener('transitionend', animationComplete);

				// fade out notification
				self.$wishlistNotification.removeClass('fade-in');
			}
		};
		
		return utilityNavWishlist.init();

	})();

	return utilityNavWishlist;

});
// END close Require.JS wrapper
